module.exports = __webpack_public_path__ + "img/caishen_460.ecf533b6.png";